import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { getOpacityColor, grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

export interface BottomSheetSettingType {
  $withBackdropFilter?: boolean;
  $roundBorder?: boolean;
  $noPadding?: boolean;
}

export const BottomSheetContainer = styled(motion.div)<BottomSheetSettingType>`
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;

  width: 100%;
  height: fit-content;
  padding: ${({ $noPadding }) => ($noPadding ? "0" : "24px 0")};
  border: 1px solid ${grayScale.main};
  border-radius: ${({ $roundBorder }) =>
    $roundBorder ? "16px 16px 0px 0px" : "0"};

  background-color: ${({ $withBackdropFilter }) =>
    $withBackdropFilter
      ? getOpacityColor(grayScale[200], 0.7)
      : grayScale[300]};

  -webkit-backdrop-filter: ${({ $withBackdropFilter }) =>
    $withBackdropFilter ? "blur(4px)" : "unset"};

  backdrop-filter: ${({ $withBackdropFilter }) =>
    $withBackdropFilter ? "blur(4px)" : "unset"};
`;

export const BottomSheetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 16px 16px 0;
`;

export const HeaderTitle = styled(Typo.Text)``;

export const CloseButton = styled.button`
  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;

  > svg {
    display: flex;
  }
`;
